<div class="p-md-12">
    <div class="p-md-3 p-toolbar-group-left ml">
        <div class="gap-header">Choose one or more gaps for measure: {{newChase.measureCode}}</div>
    </div>
    <div class="p-col-12 p-md-12 p-lg-12 ml">
        <div class="p-col-12 p-md-12 p-lg-12 ml">
            <div class="checkbox-group__fourths">
                <form [formGroup]="gapFormGroup">
                    <form-factory [formGroup]="gapFormGroup" [model]="numeratorInput"></form-factory>
                </form>
            </div>
        </div>
    </div>
    <div class="p-col-12 p-md-12 p-lg-12 mt">
        <app-button class="reset-button ml" text="RESET" (onClick)="reset()"></app-button>
        <app-button class="p-md-4 process-button next-step ml" (onClick)="nextStepProcess()" text="NEXT STEP"
            [disabled]="!isShowNextStepButton"></app-button>
    </div>
</div>